import { Request } from 'common/domain/models/request';
import { MODES } from 'common/domain/constants';
import { REQUEST_ERRORS } from 'vacations-absences.module/common/domain/constants';

const STATUS = {
  TYPE_SELECTION: 'type_selection',
  FORM_EDITION: 'form_edition',
  SUCCESS: 'success',
  REQUEST_ERROR: 'request_error',
  SICK_LEAVE_QUESTION: 'sick_leave_question'
};

class ModalRequestController {

  constructor($translate, EventEmitter, $scope) {
    'ngInject';
    this.translate = $translate;
    this.EventEmitter = EventEmitter;
    this.scope = $scope;

    this.status = STATUS.TYPE_SELECTION;
    this.modal.on('hidden.bs.modal', () => this.resetState());
    this.MAX_PERIODS = 4;
  }

  $onInit() {
    this._translate();
    this.formBackup = undefined;
    this.onGoingRequestForm = false;

    this.modal.on('show.bs.modal', () => {

      if(this.isMobileApp) {
        this.type = this.requestType;
        this.status = STATUS.FORM_EDITION;
        this.onGoingRequestForm = true;
      }

      if (this.mode === MODES.EDIT) {
        this.onGoingRequestForm = true;
        const editingSickness = Request.isSick(this.periodToEdit);
        this.status = editingSickness ? STATUS.SICK_LEAVE_QUESTION : this.status = STATUS.FORM_EDITION;
      }

      if(this.openOn) {
        this.onGoingRequestForm = true;
        this.type = this.openOn;
        this.status = STATUS.FORM_EDITION;
      }

    });
  }

  get modal () {
    return angular.element('#modalRequest');
  }
  
  emitResetModalForm(){
    this.closeModal();
  }	  

  requestQuestionShouldBeVisible() {
    return this.status === STATUS.TYPE_SELECTION;
  }

  sickLeaveQuestionShouldBeVisible(status) {
    return status === STATUS.SICK_LEAVE_QUESTION;
  }

  onSickLeaveQuestionAnswer($event) {
    this.sicknessLeaveAnswer = $event.answer;
    this.status = STATUS.FORM_EDITION;
  }

  requestFormShouldBeVisible() {
    return this.status === STATUS.FORM_EDITION;
  }

  requestNotDone() {
    return !this.requestIsSuccessful() && !this.requestIsFailed();
  }

  _translate() {
    this.translate('VACATIONS_ABSENCES.MODAL_REQUEST_HOLIDAY.ERROR_1').then((translation) => {
      this.errorMsg = translation;
    });

    this.translate('VACATIONS_ABSENCES.MODAL_REQUEST_HOLIDAY.ERROR_2').then((translation) => {
      this.errorMsgTooMuchPeriods = translation.$$unwrapTrustedValue();
    });
  }

  isRequestStepOne() {
    return this.type === undefined;
  }

  isRequestAbsences() {
    return this.type === Request.TYPES.ABSENCE;
  }

  onRequestQuestionSelect($event) {
    this.type = $event.type;
    this.onGoingRequestForm = true;
    return this.status = STATUS.FORM_EDITION;
  }

  requestIsSuccessful() {
    return this.status === STATUS.SUCCESS;
  }

  requestIsFailed() {
    return this.status === STATUS.REQUEST_ERROR;
  }

  requestSuccess() {
    this.status = STATUS.SUCCESS;
  }

  requestError($event) {
    try {
      this.errorRequestMessage = $event.data.message;
    } catch (err) {
      this.errorRequestMessage = this.errorMsg;
    }

    this.requestStatus = $event.status;
    this.errorCode = $event.data.errors.codigo;
    this.status = STATUS.REQUEST_ERROR;

  }

  onDismiss() {
    this.closeModal();
  }

  closeModal() {
    let hasErrorsToEdit = this.requestStatus === REQUEST_ERRORS.BAD_REQUEST;

    if(hasErrorsToEdit) {
      this.requestStatus = '';
      this.status = STATUS.FORM_EDITION;
      this.onGoingRequestForm = true;
      if(this.isMobileApp){
        this.openModalEvent();
      }
    }else{
      this.resetFormBackup();
      this.modal.modal('hide');
    }
  }

  resetFormBackup() {
    this.onGoingRequestForm = false;
    this.sicknessLeaveAnswer = undefined;
    this.formBackup = undefined;
  }

  resetState() {
    this.status = STATUS.TYPE_SELECTION;
  }

  goToRequestForm() {
    this.status = STATUS.FORM_EDITION;
  }

  emitData($event){
    this.selectedCategory = $event.value;
  }
}

export default ModalRequestController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/modalRequest/modalRequest.controller.js